<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        {{ lang('File conflict title') }}
      </p>
    </header>
    <section class="modal-card-body">
      <p class="conflict-ten">{{ fileName }}</p>
      <p class="conflict-duong-dan">{{ relativePath }}</p>

      <table class="conflict-bang">
        <tr>
          <td>{{ lang('Existing file') }}</td>
          <td>{{ formatBytes(existingSize) }}</td>
        </tr>
        <tr>
          <td>{{ lang('New file') }}</td>
          <td>{{ formatBytes(newSize) }}</td>
        </tr>
      </table>

      <b-checkbox v-model="applyToAll">
        {{ lang('Apply to remaining conflicts') }}
      </b-checkbox>
    </section>
    <footer class="modal-card-foot conflict-footer">
      <button class="button" @click="chon('skip')">
        {{ lang('Skip') }}
      </button>
      <button class="button" @click="chon('keepboth')">
        {{ lang('Keep both') }}
      </button>
      <button class="button is-primary" @click="chon('overwrite')">
        {{ lang('Overwrite') }}
      </button>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'ConflictDialog',
  props: ['fileName', 'relativePath', 'existingSize', 'newSize'],
  data() {
    return {
      applyToAll: false,
    }
  },
  methods: {
    chon(action) {
      this.$emit('chosen', { action, applyToAll: this.applyToAll })
      this.$parent.close()
    },
  },
}
</script>

<style scoped>
.conflict-ten {
  font-weight: 700;
  word-break: break-all;
}
.conflict-duong-dan {
  color: #7a7a7a;
  font-size: .85rem;
  margin-bottom: 14px;
  word-break: break-all;
}
.conflict-bang {
  width: 100%;
  margin-bottom: 16px;
}
.conflict-bang td {
  padding: 4px 0;
}
.conflict-bang td:first-child {
  color: #7a7a7a;
}
.conflict-bang td:last-child {
  text-align: right;
  font-weight: 600;
}
.conflict-footer {
  justify-content: flex-end;
  gap: 8px;
}
</style>
